export default __webpack_public_path__ + "static/media/feather-chevron-down.71a7bbc0.svg";